import { Component, Input } from '@angular/core';
import type { Observable } from 'rxjs';

// Services
import { GoogleMapsApiLoaderService } from '@core/helpers/google-maps-api-loader/google-maps-api-loader.service';

@Component({
  selector: 'property-map',
  templateUrl: './property-map.component.html',
  styleUrls: ['./property-map.component.sass'],
})
export class PropertyMapComponent {

  @Input() lat: number;

  @Input() lng: number;

  public mapOptions: google.maps.MapOptions = {
    zoom: 18.5,
    tilt: 45,
    mapTypeId: 'satellite',
    zoomControl: false,
    scaleControl: false,
    mapTypeControl: false,
    disableDefaultUI: true,
    draggable: false,
    gestureHandling: 'none',
    mapId: 'NO_MAP_ID', // set from const: PROPERTY_DETAILS_MAP_ID when move to official Google Maps 3d. Enable Map Tiles API in google cloud console.
  };

  public isMapsReady$: Observable<boolean> = this.googleMapsApiLoaderService.load();

  constructor(
    private googleMapsApiLoaderService: GoogleMapsApiLoaderService,
  ) {
  }

  public onMapInitialized(map: google.maps.Map): void {
    if (map) {
      const iconElement: HTMLImageElement = document.createElement('img');

      iconElement.src = 'assets/images/map_icon.svg';
      // Adding a new advanced marker to the map
      new google.maps.marker.AdvancedMarkerElement({
        map,
        position: {lat: this.lat, lng: this.lng},
        content: iconElement,
      });
    }
  }

}
